<template>
  <nav class="nav">
    <ul class="list">
      <li
        v-for="(section, idx) in sections"
        :key="section.name"
        class="list-item"
      >
        <span class="number"> {{ idx + 1 }} / {{ sections.length }} </span>

        <button class="button" @click="$emit('click', idx)">
          <div class="desktop list-item-animation">
            <span class="title">{{ section.mainNav.title }}</span>
            <span v-if="section.mainNav.subtitle" class="subtitle">
              {{ section.mainNav.subtitle }}
            </span>
          </div>

          <div class="mobile">
            <span v-if="section.mainNav.subtitle" class="title">
              {{ section.mainNav.title }} {{ section.mainNav.subtitle }}
            </span>
            <span v-else class="title">{{ section.mainNav.title }}</span>
          </div>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  computed: {
    sections() {
      return this.$store.state.sections
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;

  height: 450px;

  @include media-down(xl) {
    height: 350px;
  }

  @include media-down(lg) {
    gap: normal;
    align-items: flex-start;
    justify-content: space-between;

    max-height: unset;
    height: auto;
  }
}

.number {
  @include hide-up(lg);
  color: $main-color;
  font-family: $bold-font;
  font-size: 34px;

  @include media-down(md) {
    font-size: 16px;
  }
}

.button {
  @include reset-button;
  text-decoration: none;
  text-transform: uppercase;

  font-family: $bold-font;
  font-size: 50px;
  letter-spacing: 0.05em;
  color: $text-color;
  text-align: center;

  overflow: hidden;

  @include media-down(xl) {
    font-size: 33px;
  }

  @include media-down(lg) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    text-align: left;

    font-size: 34px;
  }

  @include media-down(md) {
    font-size: 16px;
  }

  transition: letter-spacing 0.2s;
  outline: none;

  @include media-up(lg) {
    &:hover,
    &:focus {
      letter-spacing: 0.2em;
    }
  }
}

.desktop {
  @include hide-down(lg);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mobile {
  @include hide-up(lg);
}

.title {
  @include media-down(lg) {
    margin-right: 10px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      width: 100%;
      background-color: rgba(white, 0.7);
    }
  }
}

.subtitle {
  font-size: 25px;

  @include media-down(xl) {
    font-size: 17px;
    margin-top: 2px;
  }
}

.list-item {
  @include media-down(lg) {
    margin-bottom: 37px;
  }

  @include media-down(md) {
    margin-bottom: 18px;
  }
}

.list-item-animation {
  transform: translateY(100px);
}
</style>
